/* projects/speaker-platform/src/app/molecules/statistic-menu/statistic-menu.component.scss */
.nav.nav-tabs {
  font-size: 18px;
  font-weight: 500;
  --bs-nav-tabs-border-width: 0;
}
.nav.nav-tabs .nav-link {
  color: #818181;
}
.nav.nav-tabs .nav-link.active {
  color: #505050;
}
.nav.nav-tabs .nav-link.active::after {
  content: "";
  display: block;
  width: 50%;
  height: 2px;
  background-color: #FFED00;
}
/*# sourceMappingURL=statistic-menu.component-3BQTRFUT.css.map */
